import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Search, Boxes, Loader2 } from 'lucide-react';
import Sidebar from '../components/Sidebar';

const numFmt = (n) => (n == null ? 'غير متوفر' : Number(n).toLocaleString('en-US'));
const moneyFmt = (n) => (n == null ? 'غير متوفر' : Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 }));

export default function ItemsListPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const base = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${base}/api/supply/items`);
      const j = await res.json();
      setItems(j.items || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(() => {
    const s = search.trim();
    if (!s) return items;
    return items.filter((x) => x.name.toLowerCase().includes(s.toLowerCase()));
  }, [items, search]);

  return (
    <div dir="rtl" className="supply-theme min-h-screen flex">
      <Sidebar />
      <main className="flex-1 min-w-0 p-6 md:p-8" data-testid="items-list">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
          <div>
            <div className="text-[11px] font-semibold" style={{ color: 'var(--se-emerald)' }}>ITEMS</div>
            <h1 className="se-title mt-1">الأصناف</h1>
            <div className="se-subtitle">جميع أصناف التوريد مع كمياتها وأدائها</div>
          </div>
          <div className="relative">
            <Search size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input className="se-input w-64 pr-8" placeholder="بحث باسم الصنف"
              value={search} onChange={(e) => setSearch(e.target.value)}
              data-testid="item-search" />
          </div>
        </div>

        {loading ? (
          <div className="se-panel p-12 text-center">
            <Loader2 size={26} className="animate-spin mx-auto mb-2" style={{ color: 'var(--se-emerald)' }} />
            <div className="text-slate-600 text-[13px]">جاري التحميل...</div>
          </div>
        ) : filtered.length === 0 ? (
          <div className="se-panel p-12 text-center text-slate-500">لا توجد أصناف مطابقة</div>
        ) : (
          <div className="se-panel overflow-x-auto">
            <table className="se-table">
              <thead>
                <tr>
                  <th className="w-8">#</th>
                  <th>الصنف</th>
                  <th className="text-center">الكمية المخصصة</th>
                  <th className="text-center">القيمة</th>
                  <th className="text-center">الموردون</th>
                  <th className="text-center">المدارس</th>
                </tr>
              </thead>
              <tbody>
                {filtered.slice(0, 300).map((it, i) => (
                  <tr key={i} data-testid={`item-row-${i}`}>
                    <td className="text-slate-500 tabular-nums">{i + 1}</td>
                    <td className="font-semibold">{it.name}</td>
                    <td className="text-center tabular-nums">{numFmt(it.qty)}</td>
                    <td className="text-center tabular-nums">{moneyFmt(it.value)}</td>
                    <td className="text-center tabular-nums">{numFmt(it.suppliers)}</td>
                    <td className="text-center tabular-nums">{numFmt(it.schools)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
